import { render, staticRenderFns } from "./PIModel.vue?vue&type=template&id=3f20830c&scoped=true"
import script from "./PIModel.vue?vue&type=script&lang=js"
export * from "./PIModel.vue?vue&type=script&lang=js"
import style0 from "./PIModel.vue?vue&type=style&index=0&id=3f20830c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20830c",
  null
  
)

export default component.exports